import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { VisualizadorComponent } from './index.component';

const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild([ 
    { path: 'acesso', component: VisualizadorComponent }
]);

@NgModule({
    imports: [routing],
    exports: [RouterModule],
    providers: [VisualizadorComponent]
})
export class VisualizadorRoutingModule { }
